import { jsxs as o, Fragment as s, jsx as m } from "react/jsx-runtime";
import { G as c } from "../../iconBase-CY6XudYK.js";
import "../Alert/Alert.js";
import "react";
import { cn as d } from "../../utils/cn.js";
import "../Badge/Badge.js";
import { Button as f } from "../Button/Button.js";
import "../Button/ButtonBase.js";
import "../Button/theme.js";
import "../Checkbox/Checkbox.js";
import "../ConfirmModal/index.js";
import { Typography as h } from "../Typography/index.js";
import "../TextInput/index.js";
import "../CopyToClipboard/index.js";
import "../CurrencyInput/CurrencyInput.js";
import "../Datepicker/Datepicker.js";
import "../Drawer/Drawer.js";
import "../Dropdown/index.js";
import "flowbite-react";
import "../DropdownButton/theme.js";
import "../FbDatepicker/FbDatepicker.js";
import "../FileInput/index.js";
import "../Tooltip/index.js";
import "../InlineEditableTextInput/index.js";
import "../Spinner/theme.js";
import "../Modal/index.js";
import "../Select/Select.js";
import "../Popover/index.js";
import "../RangeSlider/RangeSlider.js";
import "../../index-D0rxDWa6.js";
import "../Select/CreatableSelect.js";
import "../TabButtons/index.js";
import "../Table/index.js";
import "../Tabs/index.js";
import "../Textarea/index.js";
import "../Timeline/index.js";
import "../ToggleSwitch/index.js";
import "../ValueToggle/index.js";
import "../../config/theme/ThemeProvider.js";
import "../../hooks/useMatchMedia.js";
function x(r) {
  return c({ attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { d: "m289.94 256 95-95A24 24 0 0 0 351 127l-95 95-95-95a24 24 0 0 0-34 34l95 95-95 95a24 24 0 1 0 34 34l95-95 95 95a24 24 0 0 0 34-34z" }, child: [] }] })(r);
}
const ir = ({
  breadcrumb: r,
  title: t,
  header: p,
  onClose: i,
  className: a,
  children: e,
  ref: l,
  onScroll: n
}) => /* @__PURE__ */ o(
  "div",
  {
    onScroll: n,
    className: d("glass-tile p-8 rounded-3xl", a),
    ref: l,
    children: [
      (t || i || p) && /* @__PURE__ */ o(s, { children: [
        r,
        /* @__PURE__ */ o("div", { className: "flex items-center justify-between mx-auto gap-2", children: [
          t && /* @__PURE__ */ m(h, { variant: "titleS", children: t }),
          p,
          i && /* @__PURE__ */ m(f, { onClick: i, size: "sm", color: "glass", children: /* @__PURE__ */ m(x, { size: 16 }) })
        ] })
      ] }),
      e
    ]
  }
);
export {
  ir as Card
};
